import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AuthGuard } from './_guards';

//import { BiletcategoryComponent } from "./home/biletcategory/biletcategory.component";
//import { DashboardComponent } from "./home/dashboard/dashboard.component";
//import { BookDetailComponent } from "./home/book-detail/book-detail.component";
//import { QuizCategoriesComponent } from "./home/quiz-categories/quiz-categories.component";
//import { QuizCategoryDetailComponent } from "./home/quiz-category-detail/quiz-category-detail.component";
import { LoginComponent } from "./login/login.component";
import { DemoComponent } from "./demo/demo.component";
//import { MainComponent } from "./main/main.component";


const routes: Routes = [
  {
    path: 'main',
    loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'demo',
    component: DemoComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  
  {
    path: '',
    redirectTo: "/main",
    pathMatch: "full",
    canLoad: [AuthGuard]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
